import axios from 'axios';
import mockData from './apiContracts';

const host = 'http://139.91.183.23:8080';
// http://139.91.183.23:8080/hippalus2/Dispatch?json=true&instances=true&updateInstances=true&stateID=f65d86a8-2bde-461a-b4a6-92c0d3857e5d
const Api = {

  // receiveDatasets: async () => handle(axios.get(`${host}/hippalus/Datasets`)),
  /* receiveDatasets: async () => axios.get(`${host}/hippalus2/Datasets`), */

  /* getSessionId: async (dataset) => axios.get(`${host}/hippalus2/Explore?dataset=${dataset}`), */

  receiveDatasets:
    async () => (
      {
        data: mockData.datasetsData,
        err: false,
        errMsg: '',
        statusCode: ''
      }
    ),

  receiveAllFacetTypes:
    async () => (
      {
        data: mockData.facetsTypesAll,
        err: false,
        errMsg: '',
        statusCode: ''
      }
    ),

  receiveAllFacetSubTypes:
    async () => (
      {
        data: mockData.facetsSubTypesAll,
        err: false,
        errMsg: '',
        statusCode: ''
      }
    ),

  getMainViewCards:
    async () => (
      {
        data: mockData.mainViewCards,
        err: false,
        errMsg: '',
        statusCode: ''
      }
    ),

};

async function handle(cb) {
  const scheme = { data: null, err: false, errMsg: '', statusCode: '' }; // TODO: what else to return
  let r;
  try {
    const res = await cb();
    r = { ...scheme, ...{ data: res.data } };
  } catch (e) {
    r = { ...scheme, ...{ err: true, errMsg: e.message } };
    if (e.response) {
      r = { ...r, statusCode: e.response.status };
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
    } else if (e.request) {
      // The request was made but no response was received
      // `e.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
    } else {
      // Something happened in setting up the request that triggered an e
      // maybe just return e.message
    }
    // maybe just return e.config
  }
  return r;
}

export default Api;
